import {useQuery} from '@apollo/client';
import {UNIQUE_USER} from "../pharmacyTypeDefs";

export const useQueryUniqueUsers = (options?: any): any => (
  useQuery(UNIQUE_USER, options)
);
